"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8465],{

/***/ 14272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/_virtual/_tslib.js
var _tslib = __webpack_require__(5895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Slider.css.js
'use client';




var Container = styled_components_browser_esm/* default.div */.ZP.div(templateObject_1 || (templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    position: relative;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n"], ["\n    position: relative;\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n"])), function (_a) {
    var height = _a.height;
    return "".concat(height, "px");
});
var SliderContainer = styled_components_browser_esm/* default.div */.ZP.div(templateObject_2 || (templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n"], ["\n    width: 100%;\n    overflow: hidden;\n    display: flex;\n"])));
styled_components_browser_esm/* default.div */.ZP.div(templateObject_3 || (templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"], ["\n    display: flex;\n    gap: ", "px;\n    height: 100%;\n"])), function (_a) {
    var spaceElement = _a.spaceElement;
    return spaceElement;
});
styled_components_browser_esm/* default.div */.ZP.div(templateObject_5 || (templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    height: 100%;\n    ", "\n"], ["\n    display: inline-block;\n    height: 100%;\n    ", "\n"])), function (_a) {
    var widthElement = _a.widthElement;
    return (0,styled_components_browser_esm/* css */.iv)(templateObject_4 || (templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n        width: ", "px !important;\n    "], ["\n        width: ", "px !important;\n    "])), widthElement);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;


//# sourceMappingURL=Slider.css.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Pagination/Pagination.css.js
'use client';





var Pagination_css_Container = styled_components_browser_esm/* default.div */.ZP.div(Pagination_css_templateObject_2 || (Pagination_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n    ", "\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n    ", "\n"])), function (_a) {
    var position = _a.position, styleString = _a.styleString;
    switch (position) {
        case 'absolute':
            return (0,styled_components_browser_esm/* css */.iv)(Pagination_css_templateObject_1 || (Pagination_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    position: absolute;\n                    left: 50%;\n                    bottom: 10px;\n                    transform: translateX(-50%);\n                    ", "\n                "], ["\n                    position: absolute;\n                    left: 50%;\n                    bottom: 10px;\n                    transform: translateX(-50%);\n                    ", "\n                "])), styleString);
        default:
            return styleString;
    }
});
var PaginationWrapper = styled_components_browser_esm/* default.div */.ZP.div(Pagination_css_templateObject_3 || (Pagination_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    overflow: hidden;\n    width: ", ";\n"], ["\n    overflow: hidden;\n    width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return (width ? "".concat(width, "px") : 'auto');
});
var PaginationList = styled_components_browser_esm/* default.div */.ZP.div(Pagination_css_templateObject_4 || (Pagination_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    align-items: center;\n    transform: translateX(-", "px);\n    transition: 0.25s;\n"], ["\n    display: flex;\n    align-items: center;\n    transform: translateX(-", "px);\n    transition: 0.25s;\n"])), function (_a) {
    var xPosition = _a.xPosition;
    return xPosition;
});
var PaginationItem = styled_components_browser_esm/* default.div */.ZP.div(Pagination_css_templateObject_5 || (Pagination_css_templateObject_5 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding: 5px;\n    cursor: pointer;\n"], ["\n    padding: 5px;\n    cursor: pointer;\n"])));
var PaginationIcon = styled_components_browser_esm/* default.div */.ZP.div(templateObject_9 || (templateObject_9 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    padding-right: ", ";\n    padding-left: ", ";\n    display: inline-flex;\n    cursor: pointer;\n\n    svg path {\n        transition: 0.25s;\n    }\n\n    &:hover {\n        svg path {\n            fill: ", " !important;\n        }\n    }\n\n    ", "\n\n    ", "\n    ", "\n"], ["\n    padding-right: ", ";\n    padding-left: ", ";\n    display: inline-flex;\n    cursor: pointer;\n\n    svg path {\n        transition: 0.25s;\n    }\n\n    &:hover {\n        svg path {\n            fill: ", " !important;\n        }\n    }\n\n    ", "\n\n    ", "\n    ", "\n"])), function (_a) {
    var left = _a.left;
    return left && '15px';
}, function (_a) {
    var right = _a.right;
    return right && '15px';
}, constants/* colors.buttonColor */.O9.buttonColor, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0,styled_components_browser_esm/* css */.iv)(templateObject_6 || (templateObject_6 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            pointer-events: none;\n            opacity: 0.3;\n\n            &:hover {\n                svg path {\n                    fill: #333333 !important;\n                }\n            }\n        "], ["\n            pointer-events: none;\n            opacity: 0.3;\n\n            &:hover {\n                svg path {\n                    fill: #333333 !important;\n                }\n            }\n        "])));
}, function (_a) {
    var position = _a.position;
    switch (position) {
        case 'left':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_7 || (templateObject_7 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: white;\n                    border-radius: 50%;\n                    position: absolute;\n                    left: 10px;\n                    top: 50%;\n                    transform: translateY(-50%);\n\n                    svg {\n                        width: 24px;\n                        height: 24px;\n                    }\n                "], ["\n                    background-color: white;\n                    border-radius: 50%;\n                    position: absolute;\n                    left: 10px;\n                    top: 50%;\n                    transform: translateY(-50%);\n\n                    svg {\n                        width: 24px;\n                        height: 24px;\n                    }\n                "])));
        case 'right':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_8 || (templateObject_8 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    background-color: white;\n                    border-radius: 50%;\n                    position: absolute;\n                    right: 10px;\n                    top: 50%;\n                    transform: translateY(-50%);\n\n                    svg {\n                        width: 24px;\n                        height: 24px;\n                    }\n                "], ["\n                    background-color: white;\n                    border-radius: 50%;\n                    position: absolute;\n                    right: 10px;\n                    top: 50%;\n                    transform: translateY(-50%);\n\n                    svg {\n                        width: 24px;\n                        height: 24px;\n                    }\n                "])));
        default:
            return '';
    }
}, function (_a) {
    var styleString = _a.styleString;
    return styleString;
});
var Item = styled_components_browser_esm/* default.div */.ZP.div(templateObject_13 || (templateObject_13 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    transition: 0.25s;\n\n    ", "\n"], ["\n    transition: 0.25s;\n\n    ", "\n"])), function (_a) {
    var type = _a.type, active = _a.active;
    switch (type) {
        case 'white':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_10 || (templateObject_10 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 10px;\n                    height: 10px;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                    border: 1px solid white;\n                "], ["\n                    width: 10px;\n                    height: 10px;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                    border: 1px solid white;\n                "])), active ? 'white' : 'transparent');
        case 'whiteArrowWithPagination':
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_11 || (templateObject_11 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 10px;\n                    height: 10px;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                    border: 1px solid white;\n                "], ["\n                    width: 10px;\n                    height: 10px;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                    border: 1px solid white;\n                "])), active ? 'white' : 'transparent');
        default:
            return (0,styled_components_browser_esm/* css */.iv)(templateObject_12 || (templateObject_12 = (0,_tslib/* __makeTemplateObject */.cy)(["\n                    width: 10px;\n                    height: 10px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                "], ["\n                    width: 10px;\n                    height: 10px;\n                    border-radius: 50%;\n                    background-color: ", ";\n                "])), active ? constants/* colors.primaryColor */.O9.primaryColor : '#e5e5ea');
    }
});
var Pagination_css_templateObject_1, Pagination_css_templateObject_2, Pagination_css_templateObject_3, Pagination_css_templateObject_4, Pagination_css_templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


//# sourceMappingURL=Pagination.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowRoundedLeft/index.js
'use client';



var ArrowRoundedLeft = function () {
    return (react.createElement("svg", { width: '18px', height: '18px', viewBox: '0 0 18 18', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react.createElement("g", { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'Group', transform: 'translate(-3.000000, -3.000000)' },
                react.createElement("g", { id: 'icons/icon-arrow-left', transform: 'translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) ' },
                    react.createElement("rect", { id: 'Rectangle', fillOpacity: '0', fill: '#FFFFFF', x: '0', y: '0', width: '24', height: '24' }),
                    react.createElement("path", { d: 'M12,3 C7.03379765,3 3,7.03379765 3,12 C3,16.9662023 7.03379765,21 12,21 C16.9662023,21 21,16.9662023 21,12 C21,7.03379765 16.9662023,3 12,3 Z M12,3.7826087 C16.5427989,3.7826087 20.2173913,7.45720109 20.2173913,12 C20.2173913,16.5427989 16.5427989,20.2173913 12,20.2173913 C7.45720109,20.2173913 3.7826087,16.5427989 3.7826087,12 C3.7826087,7.45720109 7.45720109,3.7826087 12,3.7826087 Z M10.7894022,7.68342391 C10.7725882,7.68648117 10.7557747,7.69106648 10.7404891,7.69565217 C10.59375,7.72163713 10.4760531,7.82863461 10.4347826,7.97078804 C10.3935121,8.1144703 10.436311,8.26732357 10.544837,8.36820652 L14.1766304,12 L10.544837,15.6317935 C10.3889268,15.787704 10.3889268,16.0383833 10.544837,16.1942935 C10.7007475,16.350204 10.9514268,16.350204 11.107337,16.1942935 L15.0203804,12.28125 C15.0968073,12.2078804 15.1396062,12.1054687 15.1396062,12 C15.1396062,11.8945313 15.0968073,11.7921196 15.0203804,11.71875 L11.107337,7.80570652 C11.0263248,7.71858026 10.9086279,7.67425291 10.7894022,7.68342391 Z', id: 'Shape', fill: '#555555' }))))));
};
var ArrowRoundedLeft$1 = react.memo(ArrowRoundedLeft);


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Images/ArrowRoundedRight/index.js
'use client';



var ArrowRoundedRight = function () {
    return (react.createElement("svg", { width: '18px', height: '18px', viewBox: '0 0 18 18', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        react.createElement("g", { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            react.createElement("g", { id: 'atom-/-ic-/-Chevron-Right-Circle-Thin-Copy', transform: 'translate(-3.000000, -3.000000)' },
                react.createElement("rect", { id: 'Rectangle', fillOpacity: '0', fill: '#FFFFFF', x: '0', y: '0', width: '24', height: '24' }),
                react.createElement("path", { d: 'M12,3 C7.03379765,3 3,7.03379765 3,12 C3,16.9662023 7.03379765,21 12,21 C16.9662023,21 21,16.9662023 21,12 C21,7.03379765 16.9662023,3 12,3 Z M12,3.7826087 C16.5427989,3.7826087 20.2173913,7.45720109 20.2173913,12 C20.2173913,16.5427989 16.5427989,20.2173913 12,20.2173913 C7.45720109,20.2173913 3.7826087,16.5427989 3.7826087,12 C3.7826087,7.45720109 7.45720109,3.7826087 12,3.7826087 Z M10.7894022,7.68342391 C10.7725882,7.68648117 10.7557747,7.69106648 10.7404891,7.69565217 C10.59375,7.72163713 10.4760531,7.82863461 10.4347826,7.97078804 C10.3935121,8.1144703 10.436311,8.26732357 10.544837,8.36820652 L14.1766304,12 L10.544837,15.6317935 C10.3889268,15.787704 10.3889268,16.0383833 10.544837,16.1942935 C10.7007475,16.350204 10.9514268,16.350204 11.107337,16.1942935 L15.0203804,12.28125 C15.0968073,12.2078804 15.1396062,12.1054687 15.1396062,12 C15.1396062,11.8945313 15.0968073,11.7921196 15.0203804,11.71875 L11.107337,7.80570652 C11.0263248,7.71858026 10.9086279,7.67425291 10.7894022,7.68342391 Z', id: 'Shape', fill: '#555555' })))));
};
var ArrowRoundedRight$1 = react.memo(ArrowRoundedRight);


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Skeleton/index.js
var Skeleton = __webpack_require__(19357);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Pagination/index.js
'use client';








var Pagination = function (props) {
    var onItemClick = props.onItemClick, amountItem = props.amountItem, activeItem = props.activeItem, id = props.id, type = props.type, position = props.position, isLoading = props.isLoading, maxItem = props.maxItem, style = props.style, _a = props.styleString, styleString = _a === void 0 ? '' : _a, customNavigation = props.customNavigation, _b = props.isDisable, isDisable = _b === void 0 ? false : _b, isLoop = props.isLoop;
    var getWidthPaginationItem = function () {
        switch (type) {
            case 'defaultNotArrow':
                return 20;
            case 'white':
                return 30;
            case 'whiteArrowOnly':
                return 0;
            default:
                return 20;
        }
    };
    var renderPagination = function () {
        var x = 0;
        var middleItem = 0;
        if (maxItem && maxItem < amountItem) {
            middleItem = maxItem % 2 === 0 ? Math.floor(maxItem / 2) - 1 : Math.floor(maxItem / 2);
            if (activeItem > middleItem && activeItem < amountItem - middleItem) {
                x = getWidthPaginationItem() * (activeItem - middleItem);
            }
            if (activeItem >= amountItem - (maxItem - middleItem - 1)) {
                x = getWidthPaginationItem() * (amountItem - maxItem);
            }
        }
        if (amountItem <= 1)
            return react.createElement(react.Fragment, null);
        switch (type) {
            case 'defaultNotArrow':
                return (react.createElement(Pagination_css_Container, { style: style, position: position, styleString: styleString },
                    react.createElement(PaginationWrapper, { width: maxItem && getWidthPaginationItem() * maxItem },
                        react.createElement(PaginationList, { xPosition: x }, (0,_tslib/* __spreadArray */.ev)([], Array(amountItem), true).map(function (_, idx) { return (react.createElement(PaginationItem, { key: idx, "data-id": "".concat(id, "-").concat(activeItem === idx), onClick: function () { return onItemClick(idx); } },
                            react.createElement(Item, { type: type, active: activeItem === idx }))); })))));
            case 'white':
                return (react.createElement(Pagination_css_Container, { style: style, position: position, styleString: styleString },
                    react.createElement(PaginationWrapper, { width: maxItem && getWidthPaginationItem() * maxItem },
                        react.createElement(PaginationList, { xPosition: x }, (0,_tslib/* __spreadArray */.ev)([], Array(amountItem), true).map(function (_, idx) { return (react.createElement(PaginationItem, { key: idx, "data-id": "".concat(id, "-").concat(activeItem === idx), onClick: function () { return onItemClick(idx); } },
                            react.createElement(Item, { type: type, active: activeItem === idx }))); })))));
            case 'whiteArrowOnly': {
                return (react.createElement(react.Fragment, null,
                    react.createElement(PaginationIcon, { position: 'left', disabled: activeItem === 0 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem - 1); }, className: 'navigation-prev', styleString: customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.styleString }, (customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.Icon) ? customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.Icon : react.createElement(ArrowRoundedLeft$1, null)),
                    react.createElement(PaginationIcon, { position: 'right', disabled: activeItem === amountItem - 1 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem + 1); }, className: 'navigation-next', styleString: customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.styleString }, (customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.Icon) ? customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.Icon : react.createElement(ArrowRoundedRight$1, null))));
            }
            case 'whiteArrowWithPagination': {
                return (react.createElement(react.Fragment, null,
                    react.createElement(PaginationIcon, { position: 'left', disabled: activeItem === 0 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem - 1); }, className: 'navigation-prev', styleString: customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.styleString }, (customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.Icon) ? customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.prevEl.Icon : react.createElement(ArrowRoundedLeft$1, null)),
                    react.createElement(Pagination_css_Container, { style: style, position: position, styleString: styleString },
                        react.createElement(PaginationWrapper, { width: maxItem && getWidthPaginationItem() * maxItem },
                            react.createElement(PaginationList, { xPosition: x }, (0,_tslib/* __spreadArray */.ev)([], Array(amountItem), true).map(function (_, idx) { return (react.createElement(PaginationItem, { key: idx, "data-id": "".concat(id, "-").concat(activeItem === idx), onClick: function () { return onItemClick(idx); } },
                                react.createElement(Item, { type: type, active: activeItem === idx }))); })))),
                    react.createElement(PaginationIcon, { position: 'right', disabled: activeItem === amountItem - 1 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem + 1); }, className: 'navigation-next', styleString: customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.styleString }, (customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.Icon) ? customNavigation === null || customNavigation === void 0 ? void 0 : customNavigation.nextEl.Icon : react.createElement(ArrowRoundedRight$1, null))));
            }
            default:
                return (react.createElement(Pagination_css_Container, { style: style, position: position },
                    react.createElement(PaginationIcon, { left: true, disabled: activeItem === 0 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem - 1); } },
                        react.createElement(ArrowRoundedLeft$1, null)),
                    react.createElement(PaginationWrapper, { width: maxItem && getWidthPaginationItem() * maxItem },
                        react.createElement(PaginationList, { xPosition: x }, (0,_tslib/* __spreadArray */.ev)([], Array(amountItem), true).map(function (_, idx) { return (react.createElement(PaginationItem, { "data-id": "".concat(id, "-").concat(activeItem === idx), key: idx, onClick: function () { return onItemClick(idx); } },
                            react.createElement(Item, { type: type, active: activeItem === idx }))); }))),
                    react.createElement(PaginationIcon, { right: true, disabled: activeItem === amountItem - 1 && !isLoop, onClick: isDisable ? function () { } : function () { return onItemClick(activeItem + 1); } },
                        react.createElement(ArrowRoundedRight$1, null))));
        }
    };
    var renderLoading = function () {
        return (react.createElement(Pagination_css_Container, { style: style, styleString: styleString },
            react.createElement(PaginationIcon, { left: true, disabled: true },
                react.createElement(ArrowRoundedLeft$1, null)),
            react.createElement(PaginationItem, null,
                react.createElement(Skeleton/* default */.Z, { height: 10, width: 100 })),
            react.createElement(PaginationIcon, { right: true, disabled: true },
                react.createElement(ArrowRoundedRight$1, null))));
    };
    return isLoading ? renderLoading() : renderPagination();
};


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js + 1 modules
var helpers = __webpack_require__(75052);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks.js
var hooks = __webpack_require__(68664);
;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Slides/Slides.css.js
'use client';




var Slides_css_Container = styled_components_browser_esm/* default.div */.ZP.div(Slides_css_templateObject_1 || (Slides_css_templateObject_1 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: flex;\n    height: 100%;\n"], ["\n    display: flex;\n    height: 100%;\n"])));
var Slide = styled_components_browser_esm/* default.div */.ZP.div(Slides_css_templateObject_4 || (Slides_css_templateObject_4 = (0,_tslib/* __makeTemplateObject */.cy)(["\n    display: inline-block;\n    height: auto;\n\n    ", "\n\n    ", "\n"], ["\n    display: inline-block;\n    height: auto;\n\n    ", "\n\n    ", "\n"])), function (_a) {
    var widthElement = _a.widthElement;
    return widthElement && (0,styled_components_browser_esm/* css */.iv)(Slides_css_templateObject_2 || (Slides_css_templateObject_2 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            width: ", "px !important;\n        "], ["\n            width: ", "px !important;\n        "])), widthElement);
}, function (_a) {
    var spaceElement = _a.spaceElement;
    return spaceElement && (0,styled_components_browser_esm/* css */.iv)(Slides_css_templateObject_3 || (Slides_css_templateObject_3 = (0,_tslib/* __makeTemplateObject */.cy)(["\n            margin-right: ", "px;\n\n            &:last-child {\n                margin-right: 0;\n            }\n        "], ["\n            margin-right: ", "px;\n\n            &:last-child {\n                margin-right: 0;\n            }\n        "])), spaceElement);
});
var Slides_css_templateObject_1, Slides_css_templateObject_2, Slides_css_templateObject_3, Slides_css_templateObject_4;


//# sourceMappingURL=Slides.css.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/Slides/index.js
'use client';






var Slides = function (props) {
    var innerRef = props.innerRef, spaceBetween = props.spaceBetween, elementPerView = props.elementPerView, widthElement = props.widthElement, children = props.children, loading = props.loading, _a = props.loadingHeight, loadingHeight = _a === void 0 ? 250 : _a;
    var renderLoading = function () {
        return (react.createElement(Slides_css_Container, null, (0,_tslib/* __spreadArray */.ev)([], Array(elementPerView), true).map(function (_, idx) { return (react.createElement(Slide, { widthElement: widthElement, key: idx, spaceElement: spaceBetween },
            react.createElement(Skeleton/* default */.Z, { height: loadingHeight, width: widthElement }))); })));
    };
    var renderSlides = function () {
        return (react.createElement(Slides_css_Container, { ref: innerRef }, Array.isArray(children) ? (Object.values(children).map(function (item, idx) { return (react.createElement(Slide, { widthElement: widthElement, key: idx, spaceElement: spaceBetween }, item)); })) : (react.createElement(Slide, { widthElement: widthElement }, children))));
    };
    return loading ? renderLoading() : renderSlides();
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@microfrontends/react-components/components/Slider/index.js
'use client';









/**
 *
 * @author Tri, Tran Minh
 */
var Slider = function (props) {
    var slidesProps = props.slides, id = props.id, paginationProps = props.pagination, containerProps = props.container, autoEnable = props.autoEnable, _a = props.autoTime, autoTime = _a === void 0 ? 4000 : _a, loadingEnable = props.loadingEnable, loadingHeight = props.loadingHeight, _b = props.transitionTime, transitionTime = _b === void 0 ? 250 : _b, _c = props.transitionSensitivity, transitionSensitivity = _c === void 0 ? 0.15 : _c, _d = props.isRobot, isRobot = _d === void 0 ? false : _d, children = props.children;
    // init value props
    var slides = (0,_tslib/* __assign */.pi)({ spaceBetween: 8, elementPerView: 1 }, slidesProps);
    var pagination = (0,_tslib/* __assign */.pi)({ elementPerPage: 1, type: 'default', position: 'default' }, paginationProps);
    var container = (0,_tslib/* __assign */.pi)({}, containerProps);
    var _e = (0,react.useState)(null), sliderContainer = _e[0], setSliderContainer = _e[1];
    var _f = (0,react.useState)(null), innerSlider = _f[0], setInnerSlider = _f[1];
    var _g = (0,react.useState)(null), containerElement = _g[0], setContainerElement = _g[1];
    var calculateAmountOfPagination = function () {
        var childrenLength = Array.isArray(children) ? Object.values(children).length : 1;
        var elementPerView = slides.elementPerView || 0;
        var elementPerPage = pagination.elementPerPage || 0;
        if (children)
            return Math.ceil((childrenLength - elementPerView) / elementPerPage) + 1;
        else
            return 0;
    };
    var _h = (0,react.useState)(0), paginationIndex = _h[0], setPaginationIndex = _h[1];
    var _j = (0,react.useState)(calculateAmountOfPagination()), paginationAmount = _j[0], setPaginationAmount = _j[1];
    var getWidthSlideElement = function () {
        if (sliderContainer) {
            var container_1 = sliderContainer.getBoundingClientRect();
            var elementPerView = slides.elementPerView || 0;
            var spaceBetween = slides.spaceBetween || 0;
            return container_1.width / elementPerView - (spaceBetween * (elementPerView - 1)) / elementPerView;
        }
        return 0;
    };
    var smoothTransition = function (position) {
        if (innerSlider) {
            innerSlider.style.transform = "translateX(-".concat(position, "px)");
            innerSlider.style.transition = "".concat(transitionTime, "ms");
            setTimeout(function () { return (innerSlider.style.transition = '0s'); }, transitionTime);
        }
    };
    var isTouchDevice = function () {
        return !!('ontouchstart' in window);
    };
    var handlePaginationChange = function (idx) {
        if (innerSlider && sliderContainer) {
            var spaceBetween = slides.spaceBetween || 0;
            var elementPerPage = pagination.elementPerPage || 0;
            if (idx === paginationAmount - 1) {
                var outer = sliderContainer.getBoundingClientRect();
                var inner = innerSlider.getBoundingClientRect();
                var widthEachPage = inner.width - outer.width;
                setPaginationIndex(idx);
                smoothTransition(widthEachPage);
            }
            else {
                var widthEachPage = (getWidthSlideElement() + spaceBetween) * elementPerPage;
                setPaginationIndex(idx);
                smoothTransition(idx * widthEachPage);
            }
        }
    };
    // add grab and move slide event
    (0,react.useEffect)(function () {
        if (sliderContainer && innerSlider && paginationAmount) {
            var body_1 = document.querySelector('body');
            var scrollStatus_1 = ''; // detect mouse move is horizontal or vertical
            var pressed_1 = false; // mouse on press
            var startX_1; // position X when mouse down
            var x_1; // position X when mouse move
            var downX_1; // screen X when mouse down
            var downY_1; // screen Y when mouse down
            var upX_1; // screen X when mouse up
            var getInnerPosition_1 = function () {
                var position = innerSlider.style.transform.match(/[-.\d]/g);
                if (position)
                    return Number(position.join(''));
                else
                    return 0;
            };
            // move <Slides> back to position of nearest element
            var checkBoundary_1 = function () {
                var outer = sliderContainer.getBoundingClientRect();
                var inner = innerSlider.getBoundingClientRect();
                var position = getInnerPosition_1();
                var spaceBetween = slides.spaceBetween || 0;
                var elementPerPage = pagination.elementPerPage || 0;
                // handle grab slides move out container on left side
                if (position > 0) {
                    setPaginationIndex(0);
                    smoothTransition(0);
                    return;
                }
                // handle grab slides move out container on right side
                if (inner.right < outer.right) {
                    if (inner.width >= outer.width) {
                        setPaginationIndex(paginationAmount - 1);
                        smoothTransition(inner.width - outer.width);
                    }
                    else {
                        setPaginationIndex(0);
                        smoothTransition(0);
                    }
                    return;
                }
                // handle grab slides move in container
                if (position <= 0) {
                    // width on a page, a page can have so many slide
                    var widthEachPage = (getWidthSlideElement() + spaceBetween) * elementPerPage;
                    // if move to left downX < upX will rounding 0.85 -> 0 & 0.86 -> 1, make grab move smooth
                    var indexPage = Math.abs((0,helpers/* fixedNumber */.Bs)(position / widthEachPage, downX_1 < upX_1 ? 1 - transitionSensitivity : transitionSensitivity));
                    setPaginationIndex(indexPage);
                    smoothTransition(indexPage >= paginationAmount - 1 ? inner.width - outer.width : indexPage * widthEachPage);
                }
            };
            if (!isTouchDevice()) {
                // Desktop device event
                sliderContainer.addEventListener('mousedown', function (e) {
                    pressed_1 = true;
                    startX_1 = e.clientX - getInnerPosition_1();
                    downX_1 = e.clientX;
                    if (body_1)
                        body_1.style.cursor = 'grabbing';
                });
                window.addEventListener('mousemove', function (e) {
                    if (!pressed_1)
                        return;
                    e.preventDefault();
                    x_1 = e.clientX;
                    innerSlider.style.pointerEvents = 'none'; // prevent click child after mouse up
                    innerSlider.style.transform = "translateX(".concat(x_1 - startX_1, "px)");
                });
                window.addEventListener('mouseup', function (e) {
                    if (!pressed_1)
                        return;
                    if (body_1)
                        body_1.style.cursor = 'default';
                    pressed_1 = false;
                    upX_1 = e.clientX;
                    innerSlider.style.pointerEvents = 'auto';
                    checkBoundary_1();
                });
            }
            else {
                // Mobile device event
                sliderContainer.addEventListener('touchstart', function (e) {
                    pressed_1 = true;
                    downX_1 = e.changedTouches[0].pageX;
                    downY_1 = e.changedTouches[0].pageY;
                    startX_1 = e.changedTouches[0].pageX - getInnerPosition_1();
                });
                sliderContainer.addEventListener('touchmove', function (e) {
                    if (!pressed_1)
                        return;
                    // find out touch move is vertical or horizontal, do nothing if scrollStatus !== 'horizontal'
                    if (scrollStatus_1 === '' && Math.abs(downY_1 - e.changedTouches[0].pageY) > 10) {
                        scrollStatus_1 = 'vertical';
                        return;
                    }
                    if (scrollStatus_1 === '' && Math.abs(downX_1 - e.changedTouches[0].pageX) > 10) {
                        scrollStatus_1 = 'horizontal';
                        return;
                    }
                    if (scrollStatus_1 === 'horizontal') {
                        e.preventDefault();
                        x_1 = e.changedTouches[0].pageX;
                        innerSlider.style.transform = "translateX(".concat(x_1 - startX_1, "px)");
                    }
                });
                sliderContainer.addEventListener('touchend', function (e) {
                    if (!pressed_1)
                        return;
                    pressed_1 = false;
                    upX_1 = e.changedTouches[0].pageX;
                    scrollStatus_1 = '';
                    checkBoundary_1();
                });
                sliderContainer.addEventListener('touchcancel', function (e) {
                    if (!pressed_1)
                        return;
                    pressed_1 = false;
                    upX_1 = e.changedTouches[0].pageX;
                    scrollStatus_1 = '';
                    checkBoundary_1();
                });
            }
        }
    }, [innerSlider, sliderContainer, paginationAmount]);
    // add automation translate slide event
    (0,react.useEffect)(function () {
        if (autoEnable && containerElement && paginationAmount) {
            var interval_1 = null;
            var startInterval = function () {
                var elements = containerElement.querySelectorAll("[data-id^=".concat(id, "-pagination]"));
                var max = elements.length;
                var index = paginationIndex;
                elements.forEach(function (e, idx) {
                    var _a;
                    if ((_a = e.getAttribute('data-id')) === null || _a === void 0 ? void 0 : _a.includes('true'))
                        index = idx;
                });
                interval_1 = setInterval(function () {
                    if (index === max - 1) {
                        handlePaginationChange(0);
                        index = 0;
                    }
                    else {
                        handlePaginationChange(index + 1);
                        index++;
                    }
                }, autoTime);
            };
            var stopInterval = function () {
                clearInterval(interval_1);
                interval_1 = null;
            };
            startInterval();
            if (isTouchDevice()) {
                containerElement.addEventListener('touchstart', stopInterval);
                containerElement.addEventListener('touchend', startInterval);
            }
            else {
                containerElement.addEventListener('mouseover', stopInterval);
                containerElement.addEventListener('mouseout', startInterval);
            }
        }
    }, [autoEnable, containerElement, paginationAmount]);
    (0,hooks/* useDidUpdateEffect */.Dz)(function () {
        if (children && slides.elementPerView)
            setPaginationAmount(calculateAmountOfPagination());
    }, [children, slides.elementPerView]);
    return !isRobot ? (react.createElement(Container, { id: id, style: container.style, ref: setContainerElement },
        react.createElement(SliderContainer, { style: slides.style, ref: setSliderContainer },
            react.createElement(Slides, { innerRef: setInnerSlider, spaceBetween: slides.spaceBetween, elementPerView: slides.elementPerView, widthElement: getWidthSlideElement(), loading: loadingEnable, loadingHeight: loadingHeight }, children)),
        pagination.type !== 'none' && (react.createElement(Pagination, { type: pagination.type, position: pagination.position, style: pagination.style, isLoading: loadingEnable, id: "".concat(id, "-pagination"), onItemClick: function (idx) { return handlePaginationChange(idx); }, activeItem: paginationIndex, amountItem: paginationAmount, maxItem: (pagination.maxShow || 0) > paginationAmount ? paginationAmount : pagination.maxShow })))) : (react.createElement(react.Fragment, null, children));
};


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 38649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wL4": function() { return /* binding */ Colors; }
/* harmony export */ });
/* harmony import */ var _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96306);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';






















































































































































































/**
 * Don't import ReferralButton here regarding it cause "document is not defined" issue on NextJS projects.
 * e.g. microfrontends/referral-candidate
 *
 * @author Tuan, Phan Thanh
 * @since 27 Jul, 2022
 */
var Colors = {
    text: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.textColor */ .O9.textColor,
    textPlaceholder: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.textPlaceholder */ .O9.textPlaceholder,
    textGray: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.textGrayColor */ .O9.textGrayColor,
    primary: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.primaryColor */ .O9.primaryColor,
    secondary: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.secondaryColor */ .O9.secondaryColor,
    button: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.buttonColor */ .O9.buttonColor,
    info: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.infoColor */ .O9.infoColor,
    success: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.successColor */ .O9.successColor,
    danger: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.dangerColor */ .O9.dangerColor,
    highlight: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.highlightColor */ .O9.highlightColor,
    darkBlue: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.darkBlueColor */ .O9.darkBlueColor,
    bgNormal: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.bgNormal */ .O9.bgNormal,
    bgHover: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.bgHover */ .O9.bgHover,
    bgError: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.bgError */ .O9.bgError,
    bgDisable: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.bgDisable */ .O9.bgDisable,
    bgHeader: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.bgHeader */ .O9.bgHeader,
    borderNormal: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderNormal */ .O9.borderNormal,
    borderHover: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderHover */ .O9.borderHover,
    borderFocus: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderFocus */ .O9.borderFocus,
    borderError: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderError */ .O9.borderError,
    borderDisable: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderDisable */ .O9.borderDisable,
    borderCard: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderCard */ .O9.borderCard,
    cardShadow: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.cardShadow */ .O9.cardShadow,
    tagSelect: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.tagSelect */ .O9.tagSelect,
    tagSelectBorder: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.tagSelectBorder */ .O9.tagSelectBorder,
    tagHover: _Utils_constants_js__WEBPACK_IMPORTED_MODULE_1__/* .colors.tagHover */ .O9.tagHover
};


//# sourceMappingURL=index.js.map


/***/ })

}]);